
/**
 * Module dependencies.
 */

import qs from 'qs';

/**
 * `Options` type.
 */

type Options = {
  domain: string;
  protocol: string;
};

/**
 * Export `UrlResolver`.
 */

export class UrlResolver {

  /**
   * Domain.
   */

  domain: string;

  /**
   * Protocol.
   */

  protocol: string;

  /**
   * Constructor.
   */

  constructor(options: Options) {
    this.domain = options.domain;
    this.protocol = options.protocol;
  }

  /**
   * Resolve.
   */

  resolve(payspaceSlug: string, path: string, search?: any) {
    const url = new URL(path, `${this.protocol}//${payspaceSlug}.${this.domain}`);

    if (search) {
      url.search = qs.stringify(search);
    }

    return url.toString();
  }

}
